<script setup>
  import { onMounted, inject } from 'vue';
  import Stage from './Stage.vue';
  import { setPageTitle } from '@/services/utils'

  const tournament = inject('tournament')
  const currents = inject('currents')

  const level = currents.value.level
  const stage = currents.value.stage

  onMounted(() => {
    setPageTitle(tournament.value.name)
  })
</script>

<template>
  <v-alert v-if="!level" type="warning" variant="tonal" class="mb-4">
    {{ $t('message.noLevelSet') }}
  </v-alert>

  <v-alert v-else-if="!stage" type="warning" variant="tonal" class="mb-4">
    {{ $t('message.noStageSet') }}
  </v-alert>

  <Stage v-else />
</template>